import { render } from "./tw-upload.vue?vue&type=template&id=2ee8e227"
import script from "./tw-upload.vue?vue&type=script&lang=js"
export * from "./tw-upload.vue?vue&type=script&lang=js"
script.render = render

export default script